import Vuex from 'vuex';
import Vue from "vue";
import {graphqlClient} from "../utils/graphql";
import gql from "graphql-tag";
import {CHARACTERISTICS_OVERVIEW} from "@/models/queries/CharactersticsOverview";
import {DELETE_CHARACTERSTIC_MUTATION} from "@/models/mutations/DeleteCharacteristic";
import {ADD_CHARACTERiSTIC_MUTATION} from "@/models/mutations/AddCharacteristic";
import {SAVE_CHARACTERISTICS_ORDER_MUTATION} from "@/models/mutations/SaveCharacteristicsOrder";
import {CHARACTERISTIC_UNITS} from "@/models/queries/CharacteristicUnits";
import {CHARACTERISTIC_CATEGORIES_QUERY} from "@/models/queries/CharacteristicCategories";
import {CHARACTERISTIC_DATA_TYPES_QUERY} from "@/models/queries/CharacteristicDataTypes";
import { i18n } from "@/lang";


Vue.use(Vuex);

const characteristicsStore = {
    namespaced: true,
    state: {
        characteristics: [],
        categories: [],
        dataTypes: [],
        units: [],
        fetching: false,
        hasError: false,
    },
    mutations: {
        BEGIN(state) {
            state.fetching = true;
        },
        ERROR(state, message) {
            state.hasError = message;
        },
        FETCH(state, characteristics) {
            state.characteristics = characteristics.sort((c1, c2) => c1.masterSort - c2.masterSort)
            state.fetching = false;
        },
        FETCH_CATEGORIES(state, categories) {
            categories.forEach(t => t.label = t.name)
            state.categories = categories
        },
        FETCH_UNITS(state, units) {
            state.units = units
        },
        FETCH_DATA_TYPES(state, dataTypes) {
            state.dataTypes = dataTypes.map(dt => ({id: dt, label: i18n.t(`data_types.${dt}`)}))
        }
    },
    actions: {
        fetch({commit}) {
            commit('BEGIN')

            return graphqlClient.query({query: gql `${CHARACTERISTICS_OVERVIEW}`})
                .then(response => {
                    commit('FETCH', response.data.characteristics)
                })
                .catch(error => {
                    commit('ERROR', error.message)
                    console.log(error)
                });
        },
        save({}, characteristic) {
            return graphqlClient.mutate({
                mutation: ADD_CHARACTERiSTIC_MUTATION,
                variables: {
                    shortcut: characteristic.shortcut,
                    categoryId: characteristic.categoryId,
                    dataType: characteristic.data_type,
                    characteristicUnitsId: characteristic.characteristic_units_id,
                    keys: characteristic.keys,
                    isCritical: characteristic.isCritical
                }
            })
        },
        saveOrder({}, characteristics) {
            const data = characteristics.map(c => ({
                characteristicId: c.id,
                masterSort: c.master_sort
            }))
            return graphqlClient.mutate({
                mutation: gql(SAVE_CHARACTERISTICS_ORDER_MUTATION),
                variables: {
                    input: data
                }
            })
        },
        deleteCharacteristics({}, id) {
            return graphqlClient.mutate({
                mutation: gql(DELETE_CHARACTERSTIC_MUTATION),
                variables: {
                    charactersticId: id
                }
            })
        },
        fetchUnits({commit}){
            return graphqlClient.query({
                query: gql(CHARACTERISTIC_UNITS)
            }).then(response => {
                commit('FETCH_UNITS', response.data.characteristicUnits)
            })
        },
        fetchCategories({commit}) {
            return graphqlClient.query({
                query: CHARACTERISTIC_CATEGORIES_QUERY
            }).then(response => {
                commit('FETCH_CATEGORIES', response.data.characteristicCategories)
            })
        },
        fetchDataTypes({commit}) {
            return graphqlClient.query({
                query: CHARACTERISTIC_DATA_TYPES_QUERY
            }).then(response => {
                commit('FETCH_DATA_TYPES', response.data.characteristicDataTypes)
            })
        },
    },
}

export default characteristicsStore;
